
.form-subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

gz-button {
  margin-right: 15px;
}

.title-with-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-direction: row;
  margin-top: 32px;
}

#antimalware-anti-exploit-custom-applications-field {
  margin-bottom: 120px;
}

#antimalware-anti-exploit-system-wide-detections-windows-field, #antimalware-anti-exploit-system-wide-detections-linux-field {
  width: 100%;
}
